module.exports = __webpack_public_path__ + "img/Facultad_que_apasiona-xl.03845223.webp";